module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-17.435019ae.png";